import type { FilterOptions } from "./types";
import type { OtaScopeHotel } from "./types";

export const TEST_V1_RESPONSE: OtaScopeHotel[] = [
  {
    hotel_id: 12345,
    hotel_name: "Azimut Сити Отель Олимпик Москва",
    is_base: true,
    rooms: [
      {
        room_name: "Двухместный люкс двуспальная кровать",
        category: "luxe",
        prices: [
          { date: "2026-04-02", ostrovok: 19400, travelline: 17460, yandex: 18200, tbank: 17980, sutochno: 0, alean: null },
          { date: "2026-04-03", ostrovok: 16900, travelline: 13233, yandex: 14800, tbank: null, sutochno: 0, alean: null },
          { date: "2026-04-04", ostrovok: 16900, travelline: 13233, yandex: 14580, tbank: null, sutochno: 0, alean: null },
          { date: "2026-04-05", ostrovok: 16400, travelline: 12841, yandex: 14110, tbank: null, sutochno: 0, alean: null },
          { date: "2026-04-06", ostrovok: 15890, travelline: 12620, yandex: 13980, tbank: 13740, sutochno: 0, alean: 13590 },
          { date: "2026-04-07", ostrovok: 16120, travelline: 12990, yandex: 14260, tbank: 14080, sutochno: 0, alean: 13840 },
          { date: "2026-04-08", ostrovok: 16650, travelline: 13140, yandex: 14420, tbank: 14250, sutochno: 0, alean: 14010 },
        ],
      },
      {
        room_name: "Двухместный люкс с панорамным видом",
        category: "luxe",
        prices: [
          { date: "2026-04-03", ostrovok: 16900, travelline: 13233, yandex: null, tbank: null, sutochno: 0, alean: null },
          { date: "2026-04-04", ostrovok: 16900, travelline: 13233, yandex: null, tbank: null, sutochno: 0, alean: null },
          { date: "2026-04-05", ostrovok: 16420, travelline: 12920, yandex: 14180, tbank: null, sutochno: 0, alean: null },
          { date: "2026-04-06", ostrovok: 15980, travelline: 12680, yandex: 13990, tbank: 13790, sutochno: 0, alean: 13620 },
          { date: "2026-04-07", ostrovok: 16090, travelline: 12810, yandex: 14140, tbank: 13920, sutochno: 0, alean: 13780 },
          { date: "2026-04-08", ostrovok: 16230, travelline: 12940, yandex: 14280, tbank: 14060, sutochno: 0, alean: 13890 },
        ],
      },
      {
        room_name: "Апартаменты",
        category: "standard",
        prices: [
          { date: "2026-04-03", ostrovok: 23400, travelline: 18322, yandex: 18900, tbank: 18650, sutochno: 0, alean: null },
          { date: "2026-04-04", ostrovok: 22880, travelline: 17940, yandex: 18620, tbank: 18390, sutochno: 0, alean: 18150 },
          { date: "2026-04-05", ostrovok: 23400, travelline: 18322, yandex: 18850, tbank: 18500, sutochno: 0, alean: null },
          { date: "2026-04-06", ostrovok: 21980, travelline: 17660, yandex: 18240, tbank: 18010, sutochno: 0, alean: 17890 },
          { date: "2026-04-07", ostrovok: 21450, travelline: 17280, yandex: 17810, tbank: 17690, sutochno: 0, alean: 17520 },
          { date: "2026-04-08", ostrovok: 22120, travelline: 17740, yandex: 18360, tbank: 18140, sutochno: 0, alean: 17980 },
        ],
      },
    ],
  },
  {
    hotel_id: 22345,
    hotel_name: "Holiday Tagansky",
    is_base: false,
    rooms: [
      {
        room_name: "Двухместный номер стандартный 2 отдельные кровати",
        category: "standard",
        prices: [
          { date: "2026-04-02", ostrovok: null, travelline: 0, yandex: 10500, tbank: 10100, sutochno: null, alean: null },
          { date: "2026-04-03", ostrovok: 8000, travelline: 0, yandex: 8450, tbank: 8100, sutochno: null, alean: null },
          { date: "2026-04-04", ostrovok: 9500, travelline: 0, yandex: 9800, tbank: 9550, sutochno: null, alean: null },
          { date: "2026-04-05", ostrovok: 6750, travelline: 0, yandex: 7100, tbank: 6890, sutochno: null, alean: null },
          { date: "2026-04-06", ostrovok: 7120, travelline: 0, yandex: 7380, tbank: 7210, sutochno: null, alean: null },
          { date: "2026-04-07", ostrovok: 7680, travelline: 0, yandex: 7950, tbank: 7790, sutochno: null, alean: null },
          { date: "2026-04-08", ostrovok: 7340, travelline: 0, yandex: 7590, tbank: 7420, sutochno: null, alean: null },
        ],
      },
      {
        room_name: "Двухместный номер стандартный с видом на город",
        category: "standard",
        prices: [
          { date: "2026-04-02", ostrovok: 12300, travelline: 0, yandex: 11800, tbank: 11520, sutochno: null, alean: null },
          { date: "2026-04-03", ostrovok: 9800, travelline: 0, yandex: 9400, tbank: 9250, sutochno: null, alean: null },
          { date: "2026-04-04", ostrovok: 11300, travelline: 0, yandex: 10900, tbank: 10650, sutochno: null, alean: null },
          { date: "2026-04-05", ostrovok: 8370, travelline: 0, yandex: 8120, tbank: 7990, sutochno: null, alean: null },
          { date: "2026-04-06", ostrovok: 8790, travelline: 0, yandex: 8450, tbank: 8310, sutochno: null, alean: null },
          { date: "2026-04-07", ostrovok: 9020, travelline: 0, yandex: 8730, tbank: 8590, sutochno: null, alean: null },
          { date: "2026-04-08", ostrovok: 8560, travelline: 0, yandex: 8290, tbank: 8160, sutochno: null, alean: null },
        ],
      },
    ],
  },
  {
    hotel_id: 32345,
    hotel_name: "Hotel Moscow Krasnoselskaya",
    is_base: false,
    rooms: [
      {
        room_name: "Двухместный люкс двуспальная кровать",
        category: "luxe",
        prices: [
          { date: "2026-04-04", ostrovok: 15800, travelline: 0, yandex: 15280, tbank: 15020, sutochno: null, alean: null },
          { date: "2026-04-05", ostrovok: 15800, travelline: 13900, yandex: 14420, tbank: 14190, sutochno: null, alean: null },
          { date: "2026-04-06", ostrovok: 15490, travelline: 13740, yandex: 14280, tbank: 14020, sutochno: null, alean: 13860 },
          { date: "2026-04-07", ostrovok: 15120, travelline: 13510, yandex: 14040, tbank: 13890, sutochno: null, alean: 13690 },
          { date: "2026-04-08", ostrovok: 14980, travelline: 13390, yandex: 13910, tbank: 13760, sutochno: null, alean: 13540 },
        ],
      },
      {
        room_name: "Двухкомнатный люкс",
        category: "luxe",
        prices: [
          { date: "2026-04-04", ostrovok: null, travelline: 13900, yandex: 14120, tbank: null, sutochno: null, alean: null },
          { date: "2026-04-05", ostrovok: null, travelline: 13900, yandex: 14040, tbank: null, sutochno: null, alean: null },
          { date: "2026-04-06", ostrovok: null, travelline: 13660, yandex: 13880, tbank: 13720, sutochno: null, alean: null },
          { date: "2026-04-07", ostrovok: null, travelline: 13420, yandex: 13610, tbank: 13540, sutochno: null, alean: null },
          { date: "2026-04-08", ostrovok: null, travelline: 13290, yandex: 13480, tbank: 13360, sutochno: null, alean: null },
        ],
      },
      {
        room_name: "Двухместный номер Стандарт 2 отдельные кровати",
        category: "standard",
        prices: [
          { date: "2026-04-02", ostrovok: 10300, travelline: 0, yandex: 10100, tbank: 9980, sutochno: null, alean: null },
          { date: "2026-04-03", ostrovok: 7800, travelline: 0, yandex: 7940, tbank: 7820, sutochno: null, alean: null },
          { date: "2026-04-04", ostrovok: 7800, travelline: 0, yandex: 8120, tbank: 7950, sutochno: null, alean: null },
          { date: "2026-04-05", ostrovok: 7500, travelline: 0, yandex: 7780, tbank: 7630, sutochno: null, alean: null },
          { date: "2026-04-06", ostrovok: 7260, travelline: 0, yandex: 7510, tbank: 7390, sutochno: null, alean: null },
          { date: "2026-04-07", ostrovok: 7420, travelline: 0, yandex: 7690, tbank: 7540, sutochno: null, alean: null },
          { date: "2026-04-08", ostrovok: 7190, travelline: 0, yandex: 7440, tbank: 7310, sutochno: null, alean: null },
        ],
      },
      {
        room_name: "3х комнатный смежный с 3-мя двуспальными кроватями",
        category: "standard",
        prices: [
          { date: "2026-04-03", ostrovok: null, travelline: 17800, yandex: 16950, tbank: null, sutochno: null, alean: null },
          { date: "2026-04-04", ostrovok: null, travelline: 17800, yandex: 17120, tbank: null, sutochno: null, alean: null },
          { date: "2026-04-05", ostrovok: null, travelline: 17800, yandex: 16840, tbank: null, sutochno: null, alean: null },
          { date: "2026-04-06", ostrovok: null, travelline: 17260, yandex: 16520, tbank: null, sutochno: null, alean: 16380 },
          { date: "2026-04-07", ostrovok: null, travelline: 17090, yandex: 16380, tbank: 16240, sutochno: null, alean: 16190 },
          { date: "2026-04-08", ostrovok: null, travelline: 16950, yandex: 16220, tbank: 16090, sutochno: null, alean: 15980 },
        ],
      },
    ],
  },
];

export const TEST_V1_FILTER_OPTIONS: FilterOptions = {
  dataSource: [],
  category: [
    { label: "Стандарт", value: "standard" },
    { label: "Люкс", value: "luxe" },
    { label: "Апартаменты", value: "apartment" },
  ],
  ota: [
    { label: "Яндекс", value: "yandex" },
    { label: "Т-Путешествия", value: "tbank" },
    { label: "Островок", value: "ostrovok" },
    { label: "Сайт отеля", value: "travelline" },
    { label: "Alean", value: "alean" },
  ],
  meals: [
    { label: "Завтрак", value: "BB" },
    { label: "Полупансион", value: "HB" },
    { label: "Без питания", value: "RO" },
  ],
  refund: [
    { label: "Бесплатная отмена", value: "refundable" },
    { label: "Невозвратный тариф", value: "non_refundable" },
  ],
  payment: [
    { label: "Предоплата", value: "prepaid" },
    { label: "Оплата в отеле", value: "pay_at_hotel" },
  ],
  competitors: [
    { label: "Azimut Сити Отель Олимпик Москва", value: "Azimut Сити Отель Олимпик Москва" },
    { label: "Holiday Tagansky", value: "Holiday Tagansky" },
    { label: "Hotel Moscow Krasnoselskaya", value: "Hotel Moscow Krasnoselskaya" },
  ],
  room: [],
};

export const TEST_V1_CHECK_IN_RANGE = {
  from: "2026-04-02",
  to: "2026-04-08",
};

export const TEST_V1_HOTELS = [
  { label: "Azimut Сити Отель Олимпик Москва", value: "12345" },
  { label: "Holiday Tagansky", value: "22345" },
  { label: "Hotel Moscow Krasnoselskaya", value: "32345" },
];
